/** Worker Sagas */

import { apiClient, applyHeaders, buildHeaders } from "@bkry/bowline-utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { getCachedPayload } from "../cachedPayload";
import { storeIncluded } from "../dictionarySagas";
import { actions } from "./index";

/** List Saga
 */
export function* list(action) {
  const locale = yield select((state) => state.i18nState.lang);
  let headers = yield buildHeaders(locale);
  let { pageNum, itemNum, sorting, filters, endlessScroll } = action.payload;

  const apiRequest = function* () {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.ProjectDashboards.listProjectDashboardsForProject,
      {
        page: pageNum,
        items: itemNum,
        sorting: JSON.stringify(sorting),
        filters: JSON.stringify(filters),
      },
      {
        requestInterceptor: applyHeaders(headers),
      }
    );
    return payload;
  };

  const successActions = function* (payload) {
    if (payload.obj.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put(
      actions.listSuccess({ ...payload, endlessScroll: !!endlessScroll })
    );
  };

  const failActions = function* (e) {
    yield put(actions.listFail({ message: e.message, ...e }));
  };

  yield* getCachedPayload(
    "projectDashboards",
    "list",
    apiRequest,
    successActions,
    failActions
  );
}

export function* create(action) {
  let headers = yield buildHeaders();
  let { ...requestBody } = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.ProjectDashboards.createProjectDashboardForProject,
      {},
      {
        requestInterceptor: applyHeaders(headers),
        requestBody,
      }
    );
    if (payload.obj.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put(actions.createSuccess(payload.obj.data));
  } catch (e) {
    yield put(actions.createFail({ message: e.message, ...e }));
  }
}

/** Show Saga
 *  @description: connects to the showProjectDashboard operation
 *  @param {number} action.payload the Page id
 */
export function* show(action) {
  const locale = yield select((state) => state.i18nState.lang);
  let headers = yield buildHeaders(locale);

  const apiRequest = function* () {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.ProjectDashboards.showProjectDashboard,
      {
        ...action.payload,
      },
      {
        requestInterceptor: applyHeaders(headers),
      }
    );
    return payload;
  };

  const successActions = function* (payload) {
    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put(actions.showSuccess(payload));
  };

  const failActions = function* (e) {
    yield put(actions.showFail({ message: e.message, ...e }));
  };

  yield* getCachedPayload(
    "projectDashboards",
    "show",
    apiRequest,
    successActions,
    failActions
  );
}

export function* update(action) {
  const { id, ...requestBody } = action.payload;
  let headers = yield buildHeaders();
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.ProjectDashboards.updateProjectDashboard,
      { id: id },
      {
        requestInterceptor: applyHeaders(headers),
        requestBody,
      }
    );

    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });

    yield put(actions.updateSuccess(payload.obj.data));
  } catch (e) {
    yield put(actions.updateFail({ message: e.message, ...e }));
  }
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* contractTemplatesSaga() {
  yield takeEvery(actions.list, list);
  yield takeEvery(actions.show, show);
  yield takeEvery(actions.update, update);
  yield takeEvery(actions.create, create);
}
export default contractTemplatesSaga;
